import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Collections.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const Collections = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async () => {
    try {
      const response = await fetch(`${API_URL}/api/collections`);
      if (response.ok) {
        const data = await response.json();
        setCollections(data);
      }
    } catch (error) {
      console.error('Failed to fetch collections:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="collections-page">
        <div className="loading">Loading collections...</div>
      </div>
    );
  }

  return (
    <div className="collections-page">
      <div className="collections-header">
        <h1>AudArt Designs</h1>
        <p className="collections-subtitle">A selection of handcrafted pieces, alongside the spa's massage work.</p>
      </div>

      {collections.length === 0 ? (
        <div className="no-collections">
          <p>No collections available yet.</p>
          <p>Check back soon for new items!</p>
        </div>
      ) : (
        <div className="collections-grid">
          {collections.map(collection => (
            <Link
              key={collection.id}
              to={`/products?collection=${collection.id}`}
              className="collection-card"
            >
              {collection.image && (
                <div className="collection-image">
                  <img src={collection.image} alt={collection.name} />
                  <div className="collection-overlay">
                    <span className="view-collection">View Collection →</span>
                  </div>
                </div>
              )}
              <div className="collection-info">
                <h2>{collection.name}</h2>
                {collection.description && (
                  <p className="collection-description">{collection.description}</p>
                )}
                {collection._count?.products > 0 && (
                  <p className="product-count">
                    {collection._count.products} {collection._count.products === 1 ? 'item' : 'items'}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Collections;
